export const DocumentDistributeObjectDefaults = {
  Document: {
    Doc_Name: '',
    Doc_Desc: '',
    Doc_Class: '?'
  },
  Filing: {
    Public_Document_Ind: 'N',
    File_External_Ind: 'N',
    File_Drawer: '?',
    File_Folder: '?'
  }
};
